import {
  getFacet,
  getText,
  appendGOATandCountryCodeToTitle,
  sortAndSliceList,
  constructList,
} from 'shared/utils/pageMetadataUtils';
import { startCase } from 'shared/utils/startCase';

export const getSubcategoryMetadata = ({
  pageTitle,
  pageDescription,
  constructorResponse,
  locale,
  query,
}) => {
  const sneakerSubcategories = [
    'basketball',
    'boots',
    'cleats',
    'lifestyle',
    'running',
    'sandals',
    'skateboarding',
  ];

  // Pulling out static strings for translation purposes
  const isSneakerSubcategory = sneakerSubcategories.includes(query?.productSlug);
  const newReleasesIconicStyles = isSneakerSubcategory
    ? 'New Releases & Iconic Styles'
    : 'Streetwear & Luxury';
  const buy = 'Buy';
  const featuringNewReleasesAndIconicStylesFrom = 'Featuring new releases and iconic styles from';
  const onGOAT = 'on GOAT';
  const shop = 'Shop';
  const buyerProtectionGuaranteedOnAllPurchases = 'Buyer protection guaranteed on all purchases';

  const { facets = [] } = constructorResponse?.response || {};
  const brandFacet = getFacet(facets, 'brand');
  const subCategoryString: string = startCase(query?.productSlug);
  const topThreeBrandsAndMore = sortAndSliceList(brandFacet?.options, 4);

  const { constructedListWithStartCase } = constructList({
    list: topThreeBrandsAndMore,
    key: 'display_name',
  });

  constructedListWithStartCase[constructedListWithStartCase.length - 1] = 'more';

  const title = `${buy} ${subCategoryString}: ${newReleasesIconicStyles}`;
  const description = `${shop} ${subCategoryString.toLowerCase()} ${onGOAT}. ${featuringNewReleasesAndIconicStylesFrom} ${getText(
    '',
    constructedListWithStartCase,
  )}. ${buyerProtectionGuaranteedOnAllPurchases}.`;

  return {
    pageTitle: pageTitle || appendGOATandCountryCodeToTitle(title, locale),
    pageDescription: pageDescription || description,
  };
};
